import { AppData } from '../types/index';

export const appData: AppData = {
  categories: [
    {
      id: "boat-tours",
      title: "Boat Tours",
      route: "/boat-tours",
      description: "Explore the Algarve coastline with our luxury boat tours",
      image: "ai-generated-boat-picture.jpg",
      items: [
        {
          id: 1,
          name: "Ocean Quest",
          email: "info@oceanquest.com",
          logo: "Ocean Quest.png",
          description: "Explore the best of the Algarve coast with Ocean Quest. Boat tours, caves, dolphins and parasailing from Vilamoura, with a team passionate about providing unique experiences at sea. Because life is beautiful.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 18:00" },
            { day: "Tuesday", hours: "09:00 - 18:00" },
            { day: "Wednesday", hours: "09:00 - 18:00" },
            { day: "Thursday", hours: "09:00 - 18:00" },
            { day: "Friday", hours: "09:00 - 18:00" },
            { day: "Saturday", hours: "09:00 - 18:00" },
            { day: "Sunday", hours: "09:00 - 18:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 683",
          socialMedia: {
            facebook: "https://www.facebook.com/boattripsvilamoura",
            instagram: "https://www.instagram.com/oceanquestalgarve/",
            website: "https://oceanquestalgarve.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sOcean%20Quest!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "ocean quest",
          images: ["see-the-wonderful-algarvian.jpg", "swimming-stop.jpg", "traditional-cultural (1).jpg", "vilamoura-yacht-charter.jpg", "vilamoura-speed-boat-trips.jpeg", "cesar-live-on-the-guitar.jpg", "traditional-cultural.jpg", "life-is-beautiful.jpg", "exceptional-view.jpg", "dolphin-quest.jpg"]
        },
        {
          id: 2,
          name: "Cool Charters",
          email: "info@coolchartersvilamoura.com",
          logo: "Cool-Charters-BSQUAREwhite.png",
          description: "Offers personalized nautical experiences, ideal for special occasions such as birthdays, bachelor(ette) parties, weddings or corporate events. Tours include visits to caves, isolated beaches and dolphin watching, as well as aquatic activities like jet ski. The dedicated team ensures exceptional service, creating unforgettable memories at sea.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 00:00" },
            { day: "Tuesday", hours: "09:00 - 00:00" },
            { day: "Wednesday", hours: "09:00 - 00:00" },
            { day: "Thursday", hours: "09:00 - 00:00" },
            { day: "Friday", hours: "09:00 - 00:00" },
            { day: "Saturday", hours: "09:00 - 00:00" },
            { day: "Sunday", hours: "09:00 - 00:00" }
          ],
          address: "Marina de Vilamoura",
          phone: "+351 912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/coolchartersvilamoura",
            instagram: "https://www.instagram.com/coolchartersvilamoura/",
            website: "https://coolchartersvilamoura.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.114271710697!2d-8.121552223229203!3d37.078585172169184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab593e20c0315%3A0xdbad05ad5ff33887!2sCool%20Charters!5e0!3m2!1spt-PT!2spt!4v1748883117704!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "Cool Charters",
          images: [
            "3e7042db-69f6-4f1f-b8b0-487e20a38ce7.jpeg",
            "b8ce1f17-7758-47d7-9ad8-f4e8d68f6bc5.jpeg",
            "c7a1cfb6-68cf-4491-b024-306646e95c5e.jpeg",
            "cc5c2fdf-0363-4d44-a721-5c1e3dd2343d.jpeg",
            "caption.jpg",
            "caption (1).jpg",
            "caption (2).jpg",
            "discover-algarve-s-famous.jpg",
            "you-will-find-a-wonderful.jpg",
            "background5.jpg",
            "kerry-is-vilamoura-s.jpg",
            "cool.jpg"
          ]
        },
        {
          id: 3,
          name: "AlgarExperience",
          email: "info@algarexperience.com",
          logo: "algarexperience-vect.svg",
          description: "AlgarExperience is a leader in maritime tourism in the Algarve, offering unique experiences such as cave tours, dolphin watching, parasailing and barbecues on the beach. With a modern fleet and a dedicated team, it provides unforgettable moments at sea.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 20:00" },
            { day: "Tuesday", hours: "09:00 - 20:00" },
            { day: "Wednesday", hours: "09:00 - 20:00" },
            { day: "Thursday", hours: "09:00 - 20:00" },
            { day: "Friday", hours: "09:00 - 20:00" },
            { day: "Saturday", hours: "09:00 - 20:00" },
            { day: "Sunday", hours: "09:00 - 20:00" }
          ],
          address: "Algarve",
          phone: "+351 912 345 681",
          socialMedia: {
            facebook: "https://www.facebook.com/algarexperiencee",
            instagram: "https://www.instagram.com/algarexperience/",
            website: "https://algarexperience.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.162307877745!2d-8.126925009001342!3d37.077441000410495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab57f81075ba9%3A0x7aa138f8f2a3e9ed!2sAlgarExperience%20-%20Marina%20de%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748883329499!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "AlgarExperience",
          images: ["caves-coastline-tour.jpg", "dolphin-caves-catamaran.jpg", "gruta-de-benagil.jpg", "sunset.jpg", "grutas.jpg", "vista-aerea.jpg", "barbecue-na-praia.jpg", "parasailing.jpg", "belize-segundo-costa.jpg", "boat-party.jpg"]
        },
        {
          id: 4,
          name: "Condor de Vilamoura",
          email: "info@condorvilamoura.com",
          logo: "condor_logo branco.avif",
          description: "Discover the Algarve coast on the majestic Condor de Vilamoura, a 34-meter-long schooner inspired by American schooners of the 19th century. With capacity for up to 120 passengers, it offers 3-hour cruises to Praia da Galé and full-day trips to Benagil, with stops for swimming, exploring caves and enjoying a delicious barbecue on the beach. A unique experience for the whole family, combining comfort, tradition and stunning landscapes.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 18:00" },
            { day: "Tuesday", hours: "09:00 - 18:00" },
            { day: "Wednesday", hours: "09:00 - 18:00" },
            { day: "Thursday", hours: "09:00 - 18:00" },
            { day: "Friday", hours: "09:00 - 18:00" },
            { day: "Saturday", hours: "09:00 - 18:00" },
            { day: "Sunday", hours: "09:00 - 18:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 682",
          socialMedia: {
            facebook: "https://www.facebook.com/CondorDeVilamoura/",
            instagram: "https://www.instagram.com/condordevilamoura/",
            website: "https://condorvilamoura.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.126789!3d37.076543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "condor vilamoura",
          images: ["photo0jpg.jpg", "caption (1).jpg", "vamos-para-a-praia.jpg", "caption (2).jpg", "caption.jpg", "21d228_8a694355938d49048feaba57ef829db2~mv2-1.avif", "condor-de-vilamoura (1).jpg", "condor-de-vilamoura.jpg", "21d228_28814368cb5446c1b0a8d17d8459fd48~mv2.avif", "21d228_8a694355938d49048feaba57ef829db2~mv2.avif"]
        },
        {
          id: 5,
          name: "Vilamoura WaterSports Centre",
          email: "info@vilamourawatersportscentre.com",
          logo: "Vilamoura-Watersports-Centre-logo-Design-01-e1602070771419.webp",
          description: "Located in the Vilamoura Marina, the Vilamoura Watersports Centre offers a wide range of aquatic activities for all ages. From boat tours to Benagil caves, dolphin watching, parasailing, jet ski, wakeboard, fishing and private boat rentals, there are options for everyone. With an experienced team and quality equipment, they ensure safety and fun in all experiences. Open daily, it is the perfect place to explore the Algarve coast in a unique way.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 23:00" },
            { day: "Tuesday", hours: "09:00 - 23:00" },
            { day: "Wednesday", hours: "09:00 - 23:00" },
            { day: "Thursday", hours: "09:00 - 23:00" },
            { day: "Friday", hours: "09:00 - 23:00" },
            { day: "Saturday", hours: "09:00 - 23:00" },
            { day: "Sunday", hours: "09:00 - 23:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 684",
          socialMedia: {
            facebook: "https://www.facebook.com/VilamouraWatersportsCentre/?locale=pt_PT",
            instagram: "https://www.instagram.com/vilamoura_watersportscentre/",
            website: "https://www.watersportsvilamoura.com/pt-pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1531357987783!2d-8.124483123229288!3d37.07765947216944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab591f6e9b21f%3A0x407948f711a9e5ab!2sVilamoura%20Watersports%20Centre!5e0!3m2!1spt-PT!2spt!4v1748883466872!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "watersports vilamoura",
          images: ["IMG_1046-scaled.webp", "photo5jpg.jpg", "foto1.webp", "jet-boat-ride-vilamoura.jpg", "Parasailing-Vilamoura-Experience-scaled.webp", "speed-boat-algarvexcite.jpg", "parasailing-boat-trips.jpg", "common-dolphin.jpg", "Fishing-In-Algarve.webp", "Dolphins-Algarve-.webp"]
        },
        {
          id: 6,
          name: "Passeios Ria Formosa",
          email: "reservas@passeios-ria-formosa.com",
          logo: "Passeios ria formosa.png",
          description: "Explore the Ria Formosa with private tours in sailboats, speedboats, or traditional boats. Observe dolphins, seahorses, and birds, or enjoy unique experiences such as oysters with champagne, romantic dinners, exclusive catamaran trips, and kayak rentals. An invitation to discover the Algarve's nature with charm and authenticity.",
          locationIds: [5],
          openingHours: [
            { day: "Monday", hours: "08:00 - 20:00" },
            { day: "Tuesday", hours: "08:00 - 20:00" },
            { day: "Wednesday", hours: "08:00 - 20:00" },
            { day: "Thursday", hours: "08:00 - 20:00" },
            { day: "Friday", hours: "08:00 - 20:00" },
            { day: "Saturday", hours: "08:00 - 20:00" },
            { day: "Sunday", hours: "08:00 - 20:00" }
          ],
          address: "Ria Formosa",
          phone: "+351 912 345 679",
          socialMedia: {
            facebook: "https://www.facebook.com/passeiosbarcoriaformosa",
            instagram: "https://www.instagram.com/passeiosriaformosa/",
            website: "https://passeios-ria-formosa.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101892.91828023992!2d-7.896293302734396!3d37.05382039999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd05530a88105cfb%3A0x696d59f8bd24833d!2sPasseios%20Ria%20Formosa!5e0!3m2!1spt-PT!2spt!4v1748883183737!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "Passeios Ria Formosa",
          images: ["sailing-tour.jpg", "featured-2-horas-fuseta.webp", "birdwatching.jpg", "sealife-observation.jpg", "dolphins-observation.jpg", "DJI_20240427_200812_220.webp", "dji_fly_20240425_145136_206_1714164247660_timed.webp"]
        },
        {
          id: 7,
          name: "Formosamar",
          email: "info@formosamar.com",
          logo: "formosamar-main-logo-landscape-white.svg",
          description: "Formosamar, located in Faro, offers authentic experiences in the Ria Formosa Natural Park. It offers boat tours, bird and dolphin watching, as well as boat rentals, kayaks, bicycles and nautical equipment. Ideal for those who want to explore the local nature and culture with experienced guides. The company is certified in ecotourism and committed to sustainable practices.",
          locationIds: [5],
          openingHours: [
            { day: "Monday", hours: "09:00 - 19:00" },
            { day: "Tuesday", hours: "09:00 - 19:00" },
            { day: "Wednesday", hours: "09:00 - 19:00" },
            { day: "Thursday", hours: "09:00 - 19:00" },
            { day: "Friday", hours: "09:00 - 19:00" },
            { day: "Saturday", hours: "09:00 - 19:00" },
            { day: "Sunday", hours: "09:00 - 19:00" }
          ],
          address: "Ria Formosa",
          phone: "+351 912 345 680",
          socialMedia: {
            facebook: "https://www.facebook.com/formosamar/",
            instagram: "https://www.instagram.com/formosamar/",
            website: "https://formosamar.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3185.8047220482727!2d-7.9389662732313235!3d37.014454772187065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd05533874923d89%3A0xd4bf971caf98216!2sFormosamar%20-%20Boat%20Tours%20Passeios%20na%20Ria%20Formosa!5e0!3m2!1spt-PT!2spt!4v1748883209882!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "Formosamar",
          images: ["dolphin-watching-boat.jpg", "formosamar-sailboats-ria-formosa-island.jpg", "ria-formosa-islands-boat.jpg", "ilha-deserta-and-farol.jpg", "guided-boat-trip-in-ria.jpg", "formosamar-private-tour-cruise-ria-formosa-900x500.jpg", "formosamar.jpg", "formosamar (1).jpg", "formosamar (2).jpg"]
        }
      ]
    },
    {
      id: "gastronomy",
      title: "Gastronomy",
      route: "/gastronomy",
      description: "Experience exquisite cuisine at selected restaurants",
      image: "pexels-pixabay-262978.jpg",
      items: [
        {
          id: 1,
          name: "Gran Sorvete",
          email: "info@gransorvete.com",
          logo: "GranSorvete.avif",
          type: "Coffee and Ice Cream Shop",
          description: "Gran Sorvete, located at Vilamoura Marina, is renowned for its Italian artisan gelato, freshly made crepes, and waffles. In a warm and welcoming atmosphere, with stunning views of the marina and its yachts, it’s the perfect spot to enjoy a sweet treat at any time of day. Whether you want to cool off on a summer afternoon, enjoy a relaxed snack, or end a stroll along the marina with something special, Gran Sorvete is a must-visit for anyone who appreciates quality and flavor.",
          locationIds: [3],
          priceRange: 1,
          openingHours: [
            { day: "Monday", hours: "11:00 - 23:00" },
            { day: "Tuesday", hours: "11:00 - 23:00" },
            { day: "Wednesday", hours: "11:00 - 23:00" },
            { day: "Thursday", hours: "11:00 - 23:00" },
            { day: "Friday", hours: "11:00 - 23:00" },
            { day: "Saturday", hours: "11:00 - 23:00" },
            { day: "Sunday", hours: "11:00 - 23:00" }
          ],
          address: "Rua Gran Sorvete, 23",
          phone: "912 345 682",
          socialMedia: {
            facebook: "https://www.facebook.com/GranSorveteVilamoura/",
            instagram: "https://www.instagram.com/gransorvete/",
            website: "https://gransorvete.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.113234707878!2d-8.12375902322921!3d37.078609872169125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5d5d983cd55%3A0xec7bb7c81350d92!2sGran%20sorvete!5e0!3m2!1spt-PT!2spt!4v1748882811766!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "Gran Sorvete",
          images: ["crepes-also-served-with.jpg", "gran-gelato.jpg", "gran-sorvete-in-the-heart.jpg", "in-the-heart-of-the-vilamoura.jpg", "our-delicious-mini-pancakes.jpg", "hot-chocolate-served.jpg", "enjoy-the-delicious-combinatio.jpg", "gran-gelato (1).jpg"]
        },
        {
          id: 2,
          name: "Retinto - Rodízio & Wine",
          email: "retinto.vilamoura@gmail.com",
          logo: "Retinto+Vilamoura-330w.webp",
          type: "Steakhouse",
          description: "The Retinto Rodízio & Wine, in Vilamoura, stands out for its Brazilian and Argentine meat buffet, accompanied by a careful selection of wines. Cozy environment and excellent service.",
          locationIds: [3],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "18:30 - 23:30" },
            { day: "Tuesday", hours: "18:30 - 23:30" },
            { day: "Wednesday", hours: "18:30 - 23:30" },
            { day: "Thursday", hours: "18:30 - 23:30" },
            { day: "Friday", hours: "18:30 - 23:30" },
            { day: "Saturday", hours: "18:30 - 23:30" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Rua Retinto, 56",
          phone: "912 345 683",
          socialMedia: {
            facebook: "https://www.facebook.com/Retinto.Vilamoura/",
            instagram: "https://www.instagram.com/retinto.vilamoura/",
            website: "https://www.restauranteretinto.com/retinto-rodizio-n-wine"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.0845960567867!2d-8.121846809000903!3d37.07929200040834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5940c8ecbd9%3A0x6755304fce06bfca!2sRetinto%20-%20Rod%C3%ADzio%20%26%20Wine%20-%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748882848562!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Welcome Drink",
            description: ["Sparkling wine welcome drink"]
          },
          rootFolder: "Retinto",
          images: ["5c594138-f690-4ea1-add1-3fce2e15ef55.avif", "photo0jpg.jpg", "entrecote-argentino-ribye.jpg", "ff1ed75b-d71b-42f7-9d93-7f3a39464c45.jpg", "59f45f21-e373-42d3-8ed2-8946008e0b3f.jpg", "b15f5500-b73f-421d-b7bc-a9412784f5d8.webp", "b8685ec1-a1b4-4cbd-bd41-3b8cdb1bfa11.avif", "d56aaf4a-be2e-4cd3-99d9-f70d63c5826c.avif", "7701aa02-a0c2-4ec5-9af1-e1c80a4263d6.webp"],
          menuUrl: "https://www.restauranteretinto.com/retinto-rodizio-n-wine#Menu"
        },
        {
          id: 3,
          name: "Authentic",
          email: "reservations@authentic-restaurant.pt",
          logo: "Logo-Authentic-dourado.png",
          type: "International Cuisine",
          description: "The Authentic restaurant, located in Quinta do Lago, offers a sophisticated gastronomic experience, combining classic Portuguese cuisine with a contemporary touch, in a luxurious and refined environment.",
          locationIds: [1],
          priceRange: 3,
          openingHours: [
            { day: "Monday", hours: "Closed" },
            { day: "Tuesday", hours: "Closed" },
            { day: "Wednesday", hours: "18:00 - 23:00" },
            { day: "Thursday", hours: "18:00 - 23:00" },
            { day: "Friday", hours: "18:00 - 23:00" },
            { day: "Saturday", hours: "18:00 - 23:00" },
            { day: "Sunday", hours: "18:00 - 23:00" }
          ],
          address: "Rua Authentic, 45",
          phone: "912 345 679",
          socialMedia: {
            facebook: "https://www.facebook.com/p/Restaurante-Authentic-61557286149118/",
            instagram: "https://www.instagram.com/authentic_restaurant/",
            website: "https://authentic-restaurant.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12822.135700162466!2d-8.047785783215549!3d37.07197186103477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5007ddbbb2f%3A0xe5b9924c281ad489!2sAuthentic%20Restaurant!5e0!3m2!1spt-PT!2spt!4v1748882756760!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Welcome Drink",
            description: ["Welcome drink and 5% off dinner"]
          },
          rootFolder: "Authentic",
          images: ["83dcbf96-9726-4f1b-a1c7-c13c5f223b98.avif", "5e949c5e-060e-457b-ad67-b7597677c446.avif", "44aa29bd-0300-47b5-9ba5-83d8b8b19bd1.avif", "4d07f2e9-70b3-4b8b-a1e1-91fe37279165.avif", "843ccb2d-bf51-4c6a-bf0d-24ab6463b44c.avif", "ff05a4b6-f867-4243-9e4b-7141f87220af.avif", "c4bd01b2-7c29-405a-94d6-b566a0328e36.avif", "44cf2c78-1fec-4650-9ed2-eedaf4708a25.avif", "036d2880-7465-460b-9c18-61260a3de321.avif", "f818d5b4-5d61-4cc5-b0eb-e90fd92ac501.avif"],
          menuUrl: "https://authentic-restaurant.pt/wp-content/uploads/2025/06/Authentic-Menu.pdf"
        },
        {
          id: 4,
          name: "CafeZique",
          email: "cafeziquept@gmail.com",
          logo: "CAFEZIQUE-487bb404-679w.webp",
          type: "International & Mediterranean",
          description: "The CaféZique restaurant, in Loulé, combines Algarvian flavors with contemporary techniques, offering a unique gastronomic experience in a relaxed environment next to the castle.",
          locationIds: [2],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "19:00 - 22:30" },
            { day: "Tuesday", hours: "19:00 - 22:30" },
            { day: "Wednesday", hours: "19:00 - 22:30" },
            { day: "Thursday", hours: "19:00 - 22:30" },
            { day: "Friday", hours: "19:00 - 22:30" },
            { day: "Saturday", hours: "19:00 - 22:30" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Rua Cafezique, 78",
          phone: "912 345 680",
          socialMedia: {
            facebook: "https://www.facebook.com/Cafeziquept/?locale=pt_BR",
            instagram: "https://www.instagram.com/cafeziquept/",
            website: "https://www.cafezique.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3180.5625743653195!2d-8.026760923227188!3d37.13932057215254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab18b3c096f37%3A0x3d8742940db522f6!2zQ2Fmw6law69xdWU!5e0!3m2!1spt-PT!2spt!4v1748882784435!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Welcome Drink",
            description: ["Glass of sparkling wine"]
          },
          rootFolder: "CafeZique",
          images: ["0c8e01ad-d9ca-4b18-af60-26a700b19e31.avif", "b7455fd9-1912-4dc4-9d75-b6e3c18c21e1.avif", "c10b8475-9033-4f81-96a7-89723f3537a6.avif", "562a5999-384a-4fcf-876a-191a283c4417.avif", "1fc2a2ef-0625-4d3c-a43b-538301aad3c4.avif", "eb5af52c-c6c9-411a-87ba-578fa3de1e3f.avif", "47a07484-d88c-447f-91ed-4c7bf0a542c3.avif", "d59e735d-141e-4359-b024-3352c31e5b83.avif", "cff64c57-1e91-4133-a445-f033ab8f5838.avif", "98b3ee01-5726-41de-93f9-23ce6da1c1b7.avif"],
          menuUrl: "https://www.cafezique.pt/services"
        },
        {
          id: 5,
          name: "A ver Tavira",
          email: "restaurante@avertavira.pt",
          logo: "AverTavira.png",
          type: "Fine Dining",
          description: "The A Ver Tavira restaurant, awarded with a Michelin star, offers a unique gastronomic experience in the historic center of Tavira, with Algarvian flavors and a stunning view. Under the command of chef Luís Brito, combines tradition and creativity in an innovative menu.",
          locationIds: [0],
          priceRange: 3,
          openingHours: [
            { day: "Monday", hours: "Closed" },
            { day: "Tuesday", hours: "18:30 - 21:30" },
            { day: "Wednesday", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Thursday", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Friday", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Saturday", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Rua de Tavira, 12",
          phone: "912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/avertavira.restaurante/",
            instagram: "https://www.instagram.com/avertavirarestaurante/",
            website: "https://avertavira.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.1350356455455!2d-7.653902723227645!3d37.125702272156204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd100379c4264773%3A0xca74ccd84b4f6fa!2sRestaurante%20A%20Ver%20Tavira!5e0!3m2!1spt-PT!2spt!4v1748882657083!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Welcome Drink",
            description: ["Welcome Glass of Champagne"]
          },
          rootFolder: "A ver Tavira",
          images: ["borrego-feijao-bago-de.jpg", "rooftop-tavira.webp", "chefe-luis-brito.jpg", "cavala-marinada-e-gaspacho.jpg", "peixe-de-linha.jpg", "carabineiro-caril-couve.jpg", "the-detailed-combinations.jpg", "each-plate-prepared-with.jpg", "caption.jpg", "ce86969e3cec4b7bb0d0cde9e123fa0c.webp"],
          menuUrl: "https://avertavira.com/menu/"
        },
        {
          id: 6,  
          name: "Tupuq",
          email: "reservas@tupuq.pt",
          logo: "Tupuqlogo.png",
          type: "Portuguese Traditional Gastronomy",
          description: "Nestled in the heart of the Algarve, Tupuq is a welcoming restaurant where portuguese traditional flavours meet a creative touch, all paired with a stunning ocean view.",
          locationIds: [4],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "19:00 - 01:00" },
            { day: "Tuesday", hours: "19:00 - 01:00" },
            { day: "Wednesday", hours: "19:00 - 01:00" },
            { day: "Thursday", hours: "19:00 - 01:00" },
            { day: "Friday", hours: "19:00 - 01:00" },
            { day: "Saturday", hours: "19:00 - 01:00" },
            { day: "Sunday", hours: "19:00 - 01:00" }
          ],
          address: "Rua Torre da Medronheira, Olhos d'Água,",
          phone: "927 131 868",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=61576808143494",
            instagram: "https://www.instagram.com/tupuq_restaurant/",
            website: "https://www.tupuq.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.6171226797!2d-8.197666523228731!3d37.09042497216555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acbdfee471ee9%3A0x34d6eeb1f3250984!2sTupuq%20Restaurante%20%26%20Bar!5e0!3m2!1spt-PT!2spt!4v1751964426753!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "10% OFF",
            description: ["10% OFF"]
          },
          cardInfo: "Bookings must be made directly with Clever Details team.",
          rootFolder: "Tupuq",
          images: [
            "TUPUQ 1.JPG",
            "TUPUQ 2.JPG",
            "TUPUQ 3.jpg",
            "TUPUQ 4.JPG",
            "TUPUQ 5.JPG",
            "TUPUQ 6.JPG",
            "TUPUQ 7.jpg",
            "TUPUQ 8.JPG",
            "TUPUQ 9.JPG",
            "TUPUQ 11.jpg",
            "TUPUQ 12.JPG"
          ],
          menuUrl: "https://www.tupuq.pt/menu"
          },
           {
          id: 7,  
          name: "Casa da Praia by Tupuq",
          email: "reservas@casadapraiabytupuq.pt",
          logo: "cdplogo.png",
          type: "Beach Club",
          description: "Casa da Praia is a relaxed and elegant seaside retreat where time slows down, the snacks come alive, and every moment is savoured to the sound of the sea and summer.",
          locationIds: [4],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "07:00 - 19:00" },
            { day: "Tuesday", hours: "07:00 - 19:00" },
            { day: "Wednesday", hours: "07:00 - 19:00" },
            { day: "Thursday", hours: "07:00 - 19:00" },
            { day: "Friday", hours: "07:00 - 19:00" },
            { day: "Saturday", hours: "07:00 - 19:00" },
            { day: "Sunday", hours: "07:00 - 19:00" }

          ],
          address: "Rua Torre da Medronheira, Olhos d'Água,",
          phone: "927 131 869",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=61577093219124",
            instagram: "https://www.instagram.com/casadapraia_bytupuq/",
            website: "https://www.casadapraiabytupuq.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.6193988282516!2d-8.197668923228834!3d37.090370772165876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acb57c2e94b89%3A0x6281062a91947cb!2sCasa%20da%20Praia%20by%20Tupuq!5e0!3m2!1spt-PT!2spt!4v1751971364358!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "10% OFF",
            description: ["10% OFF"]
          },
          cardInfo: "Bookings must be made directly with Clever Details team.",
          rootFolder: "Casa da Praia",
          images: [
           "CDP 1.JPG",
           "CDP 3.JPG",
           "CDP 4.JPG",
           "CDP 5.JPG",
           "CDP 6.JPG",
           "CDP 7.JPG",
           "CDP 8.JPG",
           "CDP 9.JPG",
           "CDP 10.JPG",
           "CDP 11.JPG",
           "CDP 12.JPG",
          ],
          menuUrl: "https://www.casadapraiabytupuq.com/menus"
          },
          ]
          },
    {
      id: "activities",
      title: "Activities",
      route: "/activities",
      description: "Enjoy exclusive access to premium activities",
      image: "card_slides.jpg",
      items: [
        {
          id: 1,
          name: "Family Golf Park",
          email: "info@familygolfpark.com",
          logo: "family-golf-park-logo-white.png",
          description: "Located in the heart of Vilamoura, the Family Golf Park is an unmissable destination for families and groups looking for fun and leisure. With two themed mini golf courses inspired by the Roman Via Appia and Via Lusitânia, the park offers a unique experience in the midst of lush gardens and Roman architecture. In addition, it has a games area for children, a games room, a snack bar with esplanade and even a tourist train that passes through the main points of Vilamoura. Open daily, the Family Golf Park is perfect for a day of fun with the family.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "10:00 - 19:00" },
            { day: "Tuesday", hours: "10:00 - 19:00" },
            { day: "Wednesday", hours: "10:00 - 19:00" },
            { day: "Thursday", hours: "10:00 - 19:00" },
            { day: "Friday", hours: "10:00 - 19:00" },
            { day: "Saturday", hours: "10:00 - 19:00" },
            { day: "Sunday", hours: "10:00 - 19:00" }
          ],
          address: "Family Golf Park",
          phone: "+351 282 912 345",
          socialMedia: {
            facebook: "https://www.facebook.com/familygolfpark.pt",
            instagram: "https://www.instagram.com/familygolfpark/",
            website: "https://familygolfpark.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sFamily%20Golf%20Park!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "Family Golf Park",
          images: ["family-golf-park-gallery-05-min.jpg", "family-golf-park-gallery-10-min.jpg", "Legionario_2.webp", "Family-Golf-Park_2.webp", "Looping-Crazygolfe_2.webp", "family-golf-park.jpg", "lisbon-bridge.jpg", "relaxing-and-clever-minigolf.jpg", "vulcanos.jpg", "2sd-hole.jpg", "1st-hole.jpg", "welcome-to-the-best-europe.jpg"]
        },
        {
          id: 2,
          name: "Algarve Riders",
          email: "info@algarveriders.com",
          logo: "logo_algarveriders.png",
          description: "Algarve Riders is a motorcycle rental company that offers a unique experience with high-performance motorcycles. It is an ideal place to enjoy an afternoon of fun.",
          locationIds: [4],
          openingHours: [
            { day: "Monday", hours: "8:30 - 18:00" },
            { day: "Tuesday", hours: "8:30 - 18:00" },
            { day: "Wednesday", hours: "8:30 - 18:00" },
            { day: "Thursday", hours: "8:30 - 18:00" },
            { day: "Friday", hours: "8:30 - 18:00" },
            { day: "Saturday", hours: "8:30 - 18:00" },
            { day: "Sunday", hours: "8:30 - 18:00" }
          ],
          address: "Algarve Riders",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/algarveriders/?locale=pt_PT",
            instagram: "https://www.instagram.com/algarveriders/",
            website: "https://www.algarveriders.com/pt"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5144440743125!2d-8.241512908997843!3d37.09286990039514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acc1c47179d53%3A0xae8f92aa7c2a4f1e!2sAlgarve%20Riders!5e0!3m2!1spt-PT!2spt!4v1748883603455!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF -Tours", "5% OFF - Scooter"]
          },
          rootFolder: "Algarve Riders",
          images: ["algarve-riders-available.jpg", "algarve-riders-off-road (7).jpg", "algarve-riders-off-road (6).jpg", "algarve-riders-off-road (5).jpg", "algarve-riders-off-road (4).jpg", "algarve-riders-off-road (3).jpg", "algarve-riders-off-road (2).jpg", "algarve-riders-off-road (1).jpg", "algarve-quad-tours-fun.jpg", "team-building-buggy-tour.jpg", "algarve-riders-off-road.jpg"]
        },
        {
          id: 3,
          name: "Aia Racing School",
          email: "racingschool@autodromodoalgarve.com",
          logo: "Autódromo_Internacional_Algarve_logo.png",
          description: "Located in the International Algarve Circuit in Portimão, offers driving experiences in high-performance cars like Porsche, Mercedes and others. With experienced instructors and an excellent infrastructure, it provides a safe and exciting immersion in the world of motorsport",
          locationIds: [6],
          openingHours: [
            { day: "Monday", hours: "09:00 - 18:00 By appointment" },
            { day: "Tuesday", hours: "09:00 - 18:00 By appointment" },
            { day: "Wednesday", hours: "09:00 - 18:00 By appointment" },
            { day: "Thursday", hours: "09:00 - 18:00 By appointment" },
            { day: "Friday", hours: "09:00 - 18:00 By appointment" },
            { day: "Saturday", hours: "09:00 - 18:00 By appointment" },
            { day: "Sunday", hours: "09:00 - 18:00 By appointment" }
          ],
          address: "Autódromo Internacional do Algarve",
          phone: "+351 282 405 600",
          socialMedia: {
            facebook: "https://www.facebook.com/AutodromodoAlgarve/",
            instagram: "https://www.instagram.com/autodromodoalgarve/",
            website: "https://autodromodoalgarve.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.7022489145315!2d-8.633461223223954!3d37.23104267212726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1b255615ca13d7%3A0x1383e062c6c8f3e2!2sAia%20Racing%20School!5e0!3m2!1spt-PT!2spt!4v1748882929910!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "Aia Racing School",
          images: [
            "295303780_10159273014723531_8030419394435337216_n.jpg",
            "racing-school.jpg",
            "AIA-Classe-A-AMG-9-scaled.jpg",
            "AIA-AMG-GT-Preto-27-scaled-e1744045842936.jpg",
            "Davanti-AIA-Racing-School.jpg",
            "NunOrganistA_048a.jpg",
            "parceiro_70_racing_school_cf026414_3__2___1_tonemapped2b_1__2.jpg"
          ]
        },
        {
          id: 4,
          name: "Karting Portimão",
          email: "kia@parkalgar.com",
          logo: "Kartodromoalgarve.png",
          description: "The International Algarve Karting Circuit, in Portimão, is one of the largest karting tracks in Europe, with 1.531 km of length. It offers experiences for all ages, from children to adults, with karts adapted to different age groups and experience levels. In addition to being a stage for official competitions and private events, it has complete infrastructure, including restaurant, boxes and shops.",
          locationIds: [6],
          openingHours: [
            { day: "Monday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Tuesday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Wednesday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Thursday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Friday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Saturday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Sunday", hours: "09:00 - 13:00, 14:00 - 17:30" }
          ],
          address: "Parkalgar, Portimão",
          phone: "+351 282 405 650",
          socialMedia: {
            facebook: "https://www.facebook.com/kartodromo.algarve",
            instagram: "https://www.instagram.com/kartodromodoalgarve/",
            website: "https://autodromodoalgarve.com/pt/the-park/kartodromo/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.658452607274!2d-8.638724023223917!3d37.23208217212703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1b2498b60682cb%3A0xa6b4e4ed93bd2a1e!2sKart%C3%B3dromo%20Internacional%20do%20Algarve!5e0!3m2!1spt-PT!2spt!4v1748882967187!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "KartingPortimao",
          images: ["39129269_2071071279603968_9122454272632422400_n.jpg", "Kartodromo2-scaled.jpg", "490851637_1218406543617808_2741633398730202739_n.jpg", "488211910_1210059391119190_5497740365812582147_n.jpg", "489446312_1210956781029451_2393478272773825535_n.jpg", "kartodromo6-pqchj12nib2vumiq0zqzcru0robuxlzilx7rhu5n6o.jpg", "kartodromo3-pqchj12nib2vumiq0zqzcru0robuxlzilx7rhu5n6o.jpg", "490229418_1218688256922970_8436650453256995830_n.jpg", "IMG_2422.jpg"]
        },
        {
          id: 5,
          name: "Slide & Splash",
          email: "info@slidesplash.com",
          logo: "logo_slidesplash.png",
          description: "The Slide & Splash, in Lagoa, is a family-friendly water park with various attractions for all ages. In addition to exciting slides, it offers children's areas, relaxation zones and animal shows. Ideal for a day of fun in the Algarve.\n\nSeasonal Hours:\n- June: 10:00 - 17:30\n- July to September 12: 10:00 - 18:00\n- September 13 to October 31: 10:00 - 17:00",
          locationIds: [7],
          openingHours: [
            { day: "Monday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Tuesday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Wednesday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Thursday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Friday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Saturday", hours: "10:00 - 18:00 (horário varia por época)" },
            { day: "Sunday", hours: "10:00 - 18:00 (horário varia por época)" }
          ],
          address: "Vale de Deus, 8401-901 Estombar, Lagoa",
          phone: "+351 282 340 800",
          socialMedia: {
            facebook: "https://www.facebook.com/AquashowParque/?locale=pt_PT",
            instagram: "https://www.instagram.com/aquashowparkhotel/",
            website: "https://aquashowpark.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1590.2913559327294!2d-8.474625460970353!3d37.1388415930381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad7dcb0aff5c5%3A0xbe389806c01894c5!2sSlide%20%26%20Splash!5e0!3m2!1spt-PT!2spt!4v1748883086894!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["12% OFF"]
          },
          rootFolder: "Slide&Splash",
          images: ["Slide-Splash-Torre-sector-4-e-aereas_3-e1679392334545.webp", "atracoes31.jpg", "Slide-Splash-Water-Park-Algarve-Portugal.jpg", "atracoes39.jpg", "slide-splash-water-slide.jpg", "new-ride-2018-disco-river.jpg", "new-rides-2018.jpg", "black-hole.jpg", "slide-splash-2019 (1).jpg", "the-big-wave.jpg", "big-slides-tower.jpg", "slide-splash-2019.jpg", "slide-2020.jpg"]
        },
        {
          id: 6,
          name: "Zoomarine",
          email: "info@zoomarine.pt",
          logo: "logozoomarine.png",
          description: "Zoomarine, located near Albufeira, is a themed park that combines fun, education and nature. With dolphin shows, sea lions, tropical birds, water slides and an artificial beach, it is perfect for an unforgettable day with the family. A magical adventure in the heart of the Algarve!\n\nSeasonal Hours:\n- March, October, November: 10:00 - 17:00\n- April to June 22 & September 10 to September 28: 10:00 - 18:00\n- June 23 to September 7: 10:00 - 19:30",
          locationIds: [4],
          openingHours: [
            { day: "Monday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Tuesday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Wednesday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Thursday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Friday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Saturday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Sunday", hours: "10:00 - 19:30 (horário varia por época)" }
          ],
          address: "EN 125, Km 65, 8201-864 Guia, Albufeira",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/ZoomarineAlgarve/?locale=pt_PT",
            instagram: "https://www.instagram.com/zoomarine_algarve_oficial/",
            website: "https://www.zoomarine.pt/pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.16183350874!2d-8.317631323227639!3d37.12506467215641!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ace4ed8ed7ec7%3A0x8cf7b5092d8538af!2sZoomarine%20Algarve!5e0!3m2!1spt-PT!2spt!4v1748883516694!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["-3,5€ Normal", "-2,5€ Sénior/Júnior", "-12€ Dolphin Emotions"]
          },
          rootFolder: "Zoomarine",
          images: ["145.jpg", "145 (1).jpg", "145 (2).jpg", "145 (3).jpg", "145 (4).jpg", "145 (5).jpg", "145 (6).jpg", "145 (7).jpg", "145 (8).jpg", "145 (9).jpg", "145 (10).jpg", "image_processing20240617-9-uc4gqx.jpg", "Zoomarine_2.jpg", "zoomarine.jpg"],
        },
        {
          id: 7,
          name: "Aquashow",
          email: "info@aquashow.com",
          logo: "aquashow_logo.png",
          description: "The Aquashow Outdoor is the largest outdoor water park in Portugal, located in the heart of the Algarve. With giant slides, wave pool, attractions for all ages and lots of animation, it is the ideal place for a summer day full of fun, adrenaline and family or friends memories.",
          locationIds: [8],
          openingHours: [
            { day: "Monday", hours: "10:00 - 18:00" },
            { day: "Tuesday", hours: "10:00 - 18:00" },
            { day: "Wednesday", hours: "10:00 - 18:00" },
            { day: "Thursday", hours: "10:00 - 18:00" },
            { day: "Friday", hours: "10:00 - 18:00" },
            { day: "Saturday", hours: "10:00 - 18:00" },
            { day: "Sunday", hours: "10:00 - 18:00" }
          ],
          address: "Aquashow",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/AquashowParque/?locale=pt_PT",
            instagram: "https://www.instagram.com/aquashowparkhotel/",
            website: "https://aquashowpark.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5023582651565!2d-8.074484223228705!3d37.09315767216503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab575a4f4c3dd%3A0xfddc87f54582acc1!2sAQUASHOW%20-%20Waterpark%20Outdoor%20%26%20Indoor!5e0!3m2!1spt-PT!2spt!4v1748883493782!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "Aquashow",
          images: ["IMG_2075.jpg", "Galeria-03.jpg", "aquashow-park (6).jpg", "air-race.jpg", "aquashow-park (5).jpg", "aquashow-park (4).jpg", "aquashow-park (3).jpg", "aquashow-park (2).jpg", "aquashow-park (1).jpg", "aquashow-park.jpg"]
        },
        {
          id: 8,
          name: "Aqualand Algarve",
          email: "aqualandalgarve@asproparks.com",
          logo: "aqualand.webp",
          description: "Aqualand Algarve is one of the largest water parks in the country, with areas adapted for families, zones for little ones, and relaxing spaces to recharge. Between splashes, wave pools, and lazy rivers, it’s the perfect destination for a full day of family fun.",
          locationIds: [9],
          openingHours: [
              { day: "Monday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Tuesday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Wednesday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Thursday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Friday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Saturday", hours: "10:00 - 18:00 (hours may vary by season)" },
              { day: "Sunday", hours: "10:00 - 18:00 (hours may vary by season)" }

          ],
          address: "Aqualand Algarve",
          phone: "+351 282 320 230",
          socialMedia: {
            facebook: "https://www.facebook.com/aqualandalgarve",
            instagram: "https://www.instagram.com/aqualandalgarveoficial/",
            website: "https://www.aqualand.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101808.49895831558!2d-8.355817944620606!3d37.116646827524605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad0e39d6bfd4b%3A0x81a56dd58df0e845!2sAqualand%20Algarve!5e0!3m2!1spt-PT!2spt!4v1749485410610!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["€9 Off: Adult Ticket"]
          },
          rootFolder: "aqualand",
          images: ["ALG-Banzai-1-1-scaled.webp", "ALG-Kamikaze-scaled.webp", "ALG-rapids-scaled.webp", "Hydra-scaled.webp", "atracciones-1-scaled-w.webp", "banner-atracciones-1-w-1.webp", "hydra.jpg", "king-cobra.jpg", "plano-parque-scaled.webp"]
        },
        {
          id: 9,
          name: "Aquashow Indoor",
          email: "info@aquashow.com",
          logo: "aquashow_logo.png",
          description: "The first and only indoor water park in the Iberian Peninsula, with heated air and water. Relaxation pools, jacuzzis, water slides, wave pool, kids’ area and an exclusive SPA zone for guests over 13. A unique experience in Portugal for the whole family.",
          locationIds: [8],
          openingHours: [
           { day: "Monday", hours: "10:00 AM - 6:15 PM" },
            { day: "Tuesday", hours: "10:00 AM - 6:15 PM" },
            { day: "Wednesday", hours: "10:00 AM - 6:15 PM" },
            { day: "Thursday", hours: "10:00 AM - 6:15 PM" },
            { day: "Friday", hours: "10:00 AM - 6:15 PM" },
            { day: "Saturday", hours: "10:00 AM - 6:15 PM" },
            { day: "Sunday", hours: "10:00 AM - 6:15 PM" }
          ],
          address: "Aquashow",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/AquashowParque/?locale=pt_PT",
            instagram: "https://www.instagram.com/aquashowparkhotel/",
            website: "https://aquashowpark.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5023582651565!2d-8.074484223228705!3d37.09315767216503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab575a4f4c3dd%3A0xfddc87f54582acc1!2sAQUASHOW%20-%20Waterpark%20Outdoor%20%26%20Indoor!5e0!3m2!1spt-PT!2spt!4v1748883493782!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "indoor",
          images: ["indoor1.jpg", "indoor2.jpg", "indoor3.jpg", "indoor4.jpg", "indoor5.jpg", "indoor6.jpg", "indoor7.jpg", "indoor8.jpg", "indoor9.jpg"]
        },
        {
          id: 999,
          name: "Golf",
          email: "info@specialactivity.com",
          logo: "teetimesgolf.png",
          description: "Tee Times Golf agency was created over 20 years ago by Carlos Ferreira, managing partner, and has since come a long way. Today, Tee Times is one of the largest specialized golf operators in the Algarve.",
          locationIds: [3],
          isVisible: false, // Hidden from advantages page, shown on homepage
          openingHours: [
            { day: "Monday", hours: "09:00 - 17:00" },
            { day: "Tuesday", hours: "09:00 - 17:00" },
            { day: "Wednesday", hours: "09:00 - 17:00" },
            { day: "Thursday", hours: "09:00 - 17:00" },
            { day: "Friday", hours: "09:00 - 17:00" },
            { day: "Saturday", hours: "10:00 - 16:00" },
            { day: "Sunday", hours: "10:00 - 16:00" }
          ],
          address: "Vilamoura",
          phone: "+351 123 456 789",
          socialMedia: {
            facebook: "https://www.facebook.com/specialactivity",
            instagram: "https://www.instagram.com/specialactivity/",
            website: "https://www.specialactivity.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sVilamoura!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Special Offer",
            description: ["Click to visit our website"]
          },
          rootFolder: "TeeTimes",
          images: ["golf-ball-3638706.jpg"],
          redirectUrl: "http://onlinebooking.tee-times.info/affiliates.php?key=60e3cf13ac20c3bda7912ef38d45ad67&region=2"
        }
      ]
    },
    {
      id: "rent-a-car",
      title: "Rent a Car",
      route: "/rent-a-car",
      description: "Car rental across the Algarve with competitive rates",
      image: "person-preparing-get-driver-license.jpg",
      items: [
        {
         id: 1,
          name: "Movida Rent a Car",
          email: "reservas@driveonholidays.com",
          logo: "cdplogo.png",
          description: "Movida Rent a Car is a trusted partner for car rentals in Portugal, with a presence at the main airports and a modern, diverse, and constantly updated fleet. It offers a simple, fast, and flexible service, with unlimited mileage and a high standard of customer service. Clever Details clients benefit from a 5% discount on rentals. To take advantage, simply access via the provided link or use the code CLEVERDETAILS. There is also the option to have the vehicle delivered directly to the property, subject to a €40 service fee, ensuring maximum convenience during your stay.",
          locationIds: [5],
          openingHours: [
            { day: "Monday", hours: "08:00 - 20:00" },
            { day: "Tuesday", hours: "08:00 - 20:00" },
            { day: "Wednesday", hours: "08:00 - 20:00" },
            { day: "Thursday", hours: "08:00 - 20:00" },
            { day: "Friday", hours: "08:00 - 20:00" },
            { day: "Saturday", hours: "08:00 - 20:00" },
            { day: "Sunday", hours: "08:00 - 20:00" }
          ],
          address: "Faro",
          phone: "+351 212 697 488",
          socialMedia: {
            facebook: "https://www.facebook.com/movidarentacarpt/",
            instagram: "https://www.instagram.com/movidarentacarpt/",
            website: "http://www.movidarentacar.pt/pt/home?voucher=CLEVERDETAILS"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3185.1537749304584!2d-7.964972187702315!3d37.02997967206658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab2ab2cac0965%3A0xbf36117f6d51fa80!2sMovida%20Rent%20a%20Car%20-%20Faro%20Aeroporto!5e0!3m2!1spt-PT!2spt!4v1776080620743!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "movida",
          images: ["person-preparing-get-driver-license.jpg"]
        }
      ]
    },
    {
      id: "winery-tours",
      title: "Winery Tours",
      route: "/winery-tours",
      description: "Discover the finest wines of the region",
      image: "vertical-shot-person-holding-glass-wine-vineyard-sunlight.jpg",
      items: [
        {
          id: 1,
          name: "Quinta do Canhoto",
          email: "info@quintadocanhoto.com",
          logo: "LOGO_QDC_WHITE_NEW.png",
          description: "The Quinta do Canhoto, in Albufeira, is a reference in Algarve wines, combining tradition with innovation, and offers wine tastings and unique experiences in enotourism. Visits must be previously booked with 24 hours notice.",
          locationIds: [4],
          openingHours: [
            { day: "Monday", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Tuesday", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Wednesday", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Thursday", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Friday", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Saturday", hours: "Closed" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Quinta do Canhoto",
          phone: "+351 912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/p/Quinta-do-Canhoto-100049285896978/",
            instagram: "https://www.instagram.com/quinta_do_canhoto/",
            website: "https://www.quintadocanhoto.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.675044142391!2d-8.231442223228038!3d37.11285207215955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acf3201d06d49%3A0xa8045a2667997fdb!2sQuinta%20do%20Canhoto%20Adega!5e0!3m2!1spt-PT!2spt!4v1748882885204!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "Quinta do Canhoto",
          images: ["almoco-vinico.jpg", "as-vinhas.jpg", "espaco-exterior.jpg", "provas-de-vinho.jpg", "o-deck-da-adega.jpg", "great-day-out-lovely.jpg", "caption.jpg", "great-day-out-lovely (1).jpg", "great-day-out-lovely (2).jpg"]
        },
        {
          id: 2,
          name: "Morgado do Quintão",
          email: "info@morgadodoquintao.pt",
          logo: "Morgado do quintao.png",
          description: "The Morgado do Quintão, in Lagoa, combines tradition and sustainability in the production of authentic wines. It offers wine tastings and unique experiences in enotourism.",
          locationIds: [7],
          openingHours: [
            { day: "Monday", hours: "09:00 - 22:00" },
            { day: "Tuesday", hours: "09:00 - 22:00" },
            { day: "Wednesday", hours: "09:00 - 22:00" },
            { day: "Thursday", hours: "09:00 - 22:00" },
            { day: "Friday", hours: "09:00 - 22:00" },
            { day: "Saturday", hours: "09:00 - 22:00" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Morgado do Quintão",
          phone: "+351 282 912 345",
          socialMedia: {
            facebook: "https://www.facebook.com/morgadoquintao/",
            instagram: "https://www.instagram.com/morgadodoquintao/",
            website: "https://www.morgadodoquintao.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3179.790358516998!2d-8.4519159232265!3d37.157684072147326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad78519c4f4e1%3A0xe72edb7d0b164be9!2sMorgado%20do%20Quint%C3%A3o!5e0!3m2!1spt-PT!2spt!4v1748882911445!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["15% OFF"]
          },
          rootFolder: "MorgadodoQuintao",
          images: ["a-beautiful-plate-to.jpg", "morgado-do-quintao.jpg", "there-is-nothing-like.jpg", "wine-tasting-in-an-old.jpg", "palhete-our-best-selling.jpg", "typical-carapaus-alimados.jpg", "photo0jpg.jpg", "caption.jpg", "palhete-our-best-selling (1).jpg"]
        },
        {
          id: 3,
          name: "Adega do Cantor",
          email: "info@adegadocantor.com",
          logo: "Adega do Cantor.webp",
          description: "Discover the flavors of the Algarve at the Adega do Cantor, in Albufeira. Visit the vineyards, learn about the production process and taste award-winning wines in a unique enotourism experience. A must-stop for wine and nature lovers.",
          locationIds: [7],
          openingHours: [
            { day: "Monday", hours: "10:00 - 13:00, 14:00 - 17:00" },
            { day: "Tuesday", hours: "10:00 - 13:00, 14:00 - 17:00" },
            { day: "Wednesday", hours: "10:00 - 13:00, 14:00 - 17:00" },
            { day: "Thursday", hours: "10:00 - 13:00, 14:00 - 17:00" },
            { day: "Friday", hours: "10:00 - 13:00, 14:00 - 17:00" },
            { day: "Saturday", hours: "Closed" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Adega do Cantor",
          phone: "+351 282 912 345",
          socialMedia: {
            facebook: "https://www.facebook.com/adegadocantor/?locale=pt_PT",
            instagram: "https://www.instagram.com/adegadocantor_oficial/",
            website: "https://winesvidanova.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.212284376655!2d-8.281359223227659!3d37.12386427215656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ace2f02922bbf%3A0x915f96b6f61d0948!2sAdega%20do%20Cantor!5e0!3m2!1spt-PT!2spt!4v1748883379193!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% OFF"]
          },
          rootFolder: "Adega do Cantor",
          images: [
            "photo4jpg.jpg",
            "photo5jpg.jpg",
            "photo2jpg (1).jpg",
            "photo4jpg (1).jpg",
            "photo0jpg.jpg",
            "photo3jpg.jpg",
            "photo0jpg (1).jpg",
            "img-20190507-145609-largejpg.jpg",
            "img-20190507-142303-largejpg.jpg",
            "beautiful-cellar.jpg",
            "photo3jpg (1).jpg",
            "photo2jpg.jpg",
            "20181004-154037-largejpg.jpg"
          ]
        }
      ]
    },
    {
      id: "wellness",
      title: "Wellness",
      route: "/wellness",
      description: "Relax and rejuvenate with our wellness partners",
      image: "close-up-therapist-hand-massaging-woman-s-back-with-hot-towel-spa.jpg",
      items: [
        {
          id: 1,
          name: "7 Seven Spa Vilamoura",
          email: "7 Seven Spa Vilamoura@cleverdetails.com",
          logo: "7spa.svg",
          description: "The 7 Seven Spa, at Hilton Vilamoura As Cascatas Golf Resort & Spa, offers a wellness experience with 14 treatment rooms, hydrotherapy circuit, sauna, Turkish bath, jacuzzi and zen garden. Ideal for relaxation and energy renewal.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:45 - 21:00" },
            { day: "Tuesday", hours: "09:45 - 21:00" },
            { day: "Wednesday", hours: "09:45 - 21:00" },
            { day: "Thursday", hours: "09:45 - 21:00" },
            { day: "Friday", hours: "09:45 - 21:00" },
            { day: "Saturday", hours: "09:45 - 20:00" },
            { day: "Sunday", hours: "09:45 - 20:00" }
          ],
          address: "Rua das oliveiras",
          phone: "912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/7SevenSpaVilamoura",
            instagram: "https://www.instagram.com/7_spa_vilamoura/",
            website: "https://www.hilton.com/pt/hotels/faohihi-hilton-vilamoura-as-cascatas-golf-resort-and-spa/spa/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.274995797757!2d-8.123854023229336!3d37.074756772170275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5c74ac631f5%3A0xfa424fad702ea513!2sCondor%20de%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748883412407!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Special Offer",
            description: ["15% OFF the Menu", "€5 OFF Therapeutic Circuit"]
          },
          rootFolder: "7 Seven Spa Vilamoura",
          images: [
            "7-Seven-Spa_-scaled.jpg",
            "7Spa6.jpg",
            "7spa-01.jpg",
            "7spa-02.jpg",
            "FAO_70271_Hilton_Vilamoura_Golf_Resort_&_Spa_0623_07.jpg",
            "7-seven-spa-hilton-vilamoura-bem-estar-algarve_F.webp",
            "faohi-spa19-hilton-vilamoura.avif",
            "faohi-spa25-hilton-vilamoura.avif",
            "faohi-spa28-hilton-vilamoura.avif",
            "faohi-spa11-hilton-vilamoura.avif",
            "faohi-spa21-hilton-vilamoura.avif"
          ]
        },
        {
          id: 2,
          name: "Duo Spa & Life Care",
          email: "info@duospa.com",
          logo: "DuoSpacare.png",
          description: "The Duo Spa & Life Care, at Cegonha Country Club in Vilamoura, offers wellness experiences with spa circuit, sauna, Turkish bath and treatments like exfoliation or Iyashi Dome, for moments of relaxation and rejuvenation.",
          cardInfo:"You must present your membership card upon arrival.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Tuesday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Wednesday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Thursday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Friday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Saturday", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Vilamoura",
          phone: "+351 282 000 000",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=100092450604778",
            instagram: "https://www.instagram.com/duospalifecare/",
            website: "https://duospalifecare.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.683821499002!2d-8.153268823228066!3d37.11264317215962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ac975c94113ab%3A0xcc82fe0af660f648!2sDuoSpa%20%26%20Life%20Care!5e0!3m2!1spt-PT!2spt!4v1748882994473!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Premium Package",
            description: ["20% OFF Premium Treatment", "€5 OFF Menu", "Detox Circuit Access..."]
          },
          rootFolder: "Duo Spa & Life Care",
          images: [
            "474105319_527080770383605_5631574254499945256_n.jpg",
            "474381410_527080747050274_4179998407528808811_n.jpg",
            "479886329_544365938655088_6110947825713535078_n.jpg",
            "IMG_1721-1024x683.jpg",
            "piscina-interior-duo-spa-life-care-cegonha-country-club-quarteira-algarve_F.jpg",
            "Captura de ecrã 2025-05-27, às 10.50.39.png",
            "Captura de ecrã 2025-05-27, às 10.46.17.png"
          ]
          },
          {
          id: 3,
          name: "Soultice Wellness",
          email: "soulticewellness@gmail.com",
          logo: "Soultice.png",
          description: "Soultice Wellness offers personalized wellness experiences delivered directly to your holiday property. From massages, alternative therapies, yoga and nutrition to relaxation practices, everything is designed for your comfort and balance. Home service available with a €10 call-out fee. Advance booking required (minimum 24h). Take care of yourself, without leaving home.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 19:00" },
            { day: "Tuesday", hours: "09:00 - 19:00" },
            { day: "Wednesday", hours: "09:00 - 19:00" },
            { day: "Thursday", hours: "09:00 - 19:00" },
            { day: "Friday", hours: "09:00 - 19:00" },
            { day: "Saturday", hours: "09:00 - 19:00" },
            { day: "Sunday", hours: "09:00 - 19:00" }

          ],
          address: "Vilamoura",
          phone: "+351 917 681 352",
          socialMedia: {
            facebook: "",
            instagram: "https://www.instagram.com/soulticewellness/",
            website: ""
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3681.9198740027814!2d-8.090034891845523!3d37.077583268245405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab449928ec0a3%3A0xd20db14251c8033e!2sVila%20Sol%20Shopping%20Center!5e0!3m2!1spt-PT!2spt!4v1753105634800!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["20% OFF"]
          },
          rootFolder: "Soultice Wellness",
          images: [
            "Soultice 1.jpg",
            "Soultice 2.jpg",
            "Soultice 3.jpg",
            "Soultice 4.jpg",
            "Soultice 5.png",
          ]
        },
        {
          id: 4,
          name: "DMed Clinic",
          email: "info@dmedclinic.com",
          logo: "DmedClinic.png",
          description: "The DMed Clinic offers medical services at home in the entire region, including general medicine, psychology, nutrition, psychiatry and telemedicine, avoiding unnecessary trips.",
          cardInfo:"For medical assistance, please contact DMed Clinic directly at +351 916 546 408 and mention that you are a Clever Details client.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "24h" },
            { day: "Tuesday", hours: "24h" },
            { day: "Wednesday", hours: "24h" },
            { day: "Thursday", hours: "24h" },
            { day: "Friday", hours: "24h" },
            { day: "Saturday", hours: "24h" },
            { day: "Sunday", hours: "24h" }
          ],
          address: "DMed Clinic",
          phone: "+351 282 000 000",
          socialMedia: {
            facebook: "https://www.facebook.com/dmedclinic",
            instagram: "https://www.instagram.com/dmedclinic",
            website: "https://www.dmedclinic.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.123456!3d37.134567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          rootFolder: "DmedClinic",
          images: ["468288652_122196529190067954_5219035909363135589_n.jpg", "382379297_6903254336363281_5117175850526879907_n.jpg", "468219820_122196529196067954_5403389782633898697_n.jpg"]
        }
      ]
    },
    {
      id: "beauty-and-hair-salons",
      title: "Beauty & Hair Salons",
      route: "/beauty-and-hair-salons",
      description: "Private dining experience in your accommodation",
      image: "pexels-valeriya-939836.jpg",
      items: [
        {
          id: 2,
          name: "Matilde",
          email: "teresa.estetica@live.com.pt",
          logo: "matildelogo2.png",
          description: "Matilde Alves Hair Studio in Vilamoura offers outstanding service and beautiful results. Located on Av. Tivoli, opposite Hotel Dom Pedro, it’s known for skill, professionalism and a welcoming touch.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "Closed" },
            { day: "Tuesday", hours: "09:00 - 19:00" },
            { day: "Wednesday", hours: "09:00 - 19:00" },
            { day: "Thursday", hours: "09:00 - 19:00" },
            { day: "Friday", hours: "09:00 - 19:00" },
            { day: "Saturday", hours: "09:00 - 19:00" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Vilamoura",
          phone: "+351 289 302 807",
          socialMedia: {
            facebook: "https://www.facebook.com/MatildeCabeleireiroVilamoura",
            instagram: "https://www.instagram.com/matilde_cabeleireiro/",
            website: "https://quarteira.empresasportugal.net/hair-care/matilde-cabeleireiro/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6366.490908187981!2d-8.117661923229319!3d37.07546047216995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab597022a1131%3A0x6f4e5cea9d557db8!2sMatilde%20Cabeleireiro%20(%20vilamoura%20Portugal%20)!5e0!3m2!1spt-PT!2spt!4v1750672594399!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% OFF"]
          },
          rootFolder: "Matilde",
          images: ["matilde1.webp", "matilde2.webp", "matilde3.webp", "matilde4.webp", "matilde5.webp", "matilde6.webp", "matilde7.webp", "matilde8.webp", "matilde9.webp"],
        }
      ]
    },
    {
      id: "chef-at-home",
      title: "Chef at Home",
      route: "/chef-at-home",
      description: "Experience gourmet dining in the comfort of your home",
      image: "professional-chef-preparing-food-kitchen.jpg",
      items: [
        {
          id: 1,
          name: "Chef André Simão",
          email: "asimao2@hotmail.com",
          logo: "teste",
          description: "Executive chef of the Monte Rei where the recommended restaurant by the Michelin guide, Vistas Monte Rei. Provides relaxed cooking styles, to bring friends and family to the table with tapas & drinks, barbecue, Algarvian menu or tasting menu in 5 moments for more detailed celebrations.",
          locationIds: [],
          openingHours: [
            { day: "Monday", hours: "By appointment" },
            { day: "Tuesday", hours: "By appointment" },
            { day: "Wednesday", hours: "By appointment" },
            { day: "Thursday", hours: "By appointment" },
            { day: "Friday", hours: "By appointment" },
            { day: "Saturday", hours: "By appointment" },
            { day: "Sunday", hours: "By appointment" }
          ],
          address: "Service at your location",
          phone: "9251500",
          socialMedia: {
            facebook: "https://www.facebook.com/chefandresimao",
            instagram: "https://www.instagram.com/chefandresimao",
            website: "https://www.chefandresimao.pt"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.178901!3d37.112345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Welcome Package",
            description: ["Porto wine and traditional Algarve sweets"]
          },
          rootFolder: "ChefAndreSimao",
          images: ["Captura de ecrã 2025-05-30, às 14.00.44.png", "Captura de ecrã 2025-05-30, às 14.01.45.png", "Captura de ecrã 2025-05-30, às 14.01.52.png", "Captura de ecrã 2025-05-30, às 14.01.18.png", "Captura de ecrã 2025-05-30, às 14.01.05.png", "Captura de ecrã 2025-05-30, às 14.02.12.png", "Captura de ecrã 2025-05-30, às 14.02.29.png", "Captura de ecrã 2025-05-30, às 14.00.58.png"]
        },
        {
          id: 2,
          name: "Fancy Kitchen Algarve",
          email: "info@fancykitchenalgarve.com",
          logo: "Fancy kitchen.webp",
          description: "The Fancy Kitchen Algarve offers exclusive gastronomic experiences with private chefs and personalized catering, elevating each moment with sophistication and flavor.",
          locationIds: [],
          openingHours: [
            { day: "Monday", hours: "By appointment" },
            { day: "Tuesday", hours: "By appointment" },
            { day: "Wednesday", hours: "By appointment" },
            { day: "Thursday", hours: "By appointment" },
            { day: "Friday", hours: "By appointment" },
            { day: "Saturday", hours: "By appointment" },
            { day: "Sunday", hours: "By appointment" }
          ],
          address: "Service at your location",
          phone: "912 345 681",
          socialMedia: {
            facebook: "https://www.facebook.com/fancykitchen",
            instagram: "https://www.instagram.com/fancykitchen",
            website: "https://www.fancykitchenalgarve.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.142345!3d37.087654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Welcome Package",
            description: ["Glass of Sparkling Wine and 2 Canapés per Person"]
          },
          rootFolder: "Fancy Kitchen",
          images: [
            "rs=w_700,cg_true,m.webp",
            "rs=w_800,cg_true,m.webp",
            "rs=w_612,cg_true,m.webp",
            "rs=w_1200,cg_true,m (2).webp",
            "rs=w_1200,cg_true,m (3).webp",
            "rs=w_1200,cg_true,m.webp",
            "rs=w_1200,cg_true,m (1).webp"
          ]
        }
      ]
    }
  ],
  locations: [
    {
      id: 0,
      name: "Tavira",
      image: "/location1.jpg",
      description: "Tavira is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 1,
      name: "Quinta do Lago",
      image: "/location2.jpg",
      description: "Quinta do Lago is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 2,
      name: "Loulé",
      image: "/location3.jpg",
      description: "Loulé is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 3,
      name: "Vilamoura",
      image: "/location4.jpg",
      description: "Vilamoura is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 4,
      name: "Albufeira",
      image: "/location5.jpg",
      description: "Albufeira is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 5,
      name: "Faro",
      image: "/location5.jpg",
      description: "Faro is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 6,
      name: "Portimão",
      image: "/location5.jpg",
      description: "Portimão is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 7,
      name: "Lagoa",
      image: "/location5.jpg",
      description: "Lagoa is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 8,
      name: "Quarteira",
      image: "/location5.jpg",
      description: "Quarteira is a beautiful city in the Algarve, Portugal. It is known for its beautiful beaches and its vibrant nightlife.",
    },
    {
      id: 9,
      name: "Alcantarilha",
      image: "/location5.jpg",
      description: "Quarteira é uma cidade costeira tradicional com um extenso passeio marítimo e excelentes restaurantes de peixe e marisco.",
    }
  ],
  ui: {
    header: {
      phoneLabel: "(National fixed call network)",
      menu: {
        advantages: "Advantages",
        access: "Access",
        partnership: "Partnership",
        about: "Did you know...",
        contact: "Contact"
      }
    },
    sidebar: {
      categories: "Categories",
      other: "Other",
      language: "Language"
    },
    searchBar: {
      searchPlaceholder: "Search experiences...",
      allCategories: "All Categories",
      allLocations: "All Locations"
    },
    listPage: {
      specialOffer: "Special Offer"
    },
    footer: {
      bookHoliday: "Book your holiday home",
      allRightsReserved: "All rights reserved"
    },
    homepage: {
      title: "Clever Member",
      subtitle: "Enjoy Exclusive Rewards",
      seeMore: "See more",
      store: "Store",
      new: "NEW"
    },
    access: {
      mainText1: "These advantages are reserved for those who book their holiday with Clever Details or entrust us with their property. It's our way of saying thank you by making your stay or investment even more rewarding.",
      mainText2: "Explore the full list of partner perks and enjoy more than just a stay.",
      mainText3: "With Clever Details, your holiday or home comes with much more than just a key.",
      exploreHomes: "Explore Our Homes"
    },
    partnership: {
      title: "Why Partner with Clever Details?",
      benefit1: {
        title: "Reach over 6,000 quality guests annually",
        description: "Our network includes thousands of national and international tourists who value local experiences"
      },
      benefit2: {
        title: "Boost your business visibility",
        description: "We highlight your business on our website and social media, increasing your reach."
      },
      form: {
        title: "Partnership Application",
        businessName: "Business Name",
        contactName: "Contact Name",
        email: "Email",
        phone: "Phone",
        businessType: {
          label: "Business Type",
          placeholder: "Select a business type",
          options: {
            boatTours: "Boat Tours",
            restaurants: "Restaurants",
            activities: "Activities",
            winery: "Winery",
            wellness: "Wellness",
            chefService: "Chef Service",
            other: "Other"
          }
        },
        description: "Business Description",
        submit: "Submit Application",
        submitting: "Submitting..."
      }
    },
    about: {
      title: "The History of Vilamoura and its Marina",
      subtitle: "From a Farm in the Algarve to an International Tourist Destination",
      video: {
        title: "Discover the history"
      },
      curiosities: {
        title: "7 Curiosities of Vilamoura"
      },
      history: {
        visionaryDream: {
          title: "The Visionary Dream of Arthur Cupertino de Miranda",
          content: "In the 1960s, the Algarve was one of the poorest regions in Portugal. In 1964, banker and entrepreneur Arthur Cupertino de Miranda acquired the former \"Quinta de Quarteira\" with a bold vision: to transform agricultural land into one of the country's largest tourist hubs.\n\nHis idea seemed eccentric for the time: building a planned city from scratch, with hotels, casino, golf courses and a marina, something unprecedented in Portugal. But time proved he was far ahead of his generation.",
          image: "/images/01-quinta-do-morgado-1960s - cópia.jpg"
        },
        primeiroSimbolo: {
          title: "First Symbol of Vilamoura",
          content: "This was the first symbol of Vilamoura.\nThe rooster was chosen by the founder himself, Arthur Cupertino de Miranda, who was originally from the north of Portugal.",
          image: "/images/Captura de ecrã 2025-09-22, às 15.54.25.jpeg"
        },
        marinaBirth: {
          title: "The Birth of Vilamoura Marina",
          content: "In 1970 the government officially approved the project and, the following year, excavations for the future marina began.\nThree years later, in April 1974, Portugal's first marina was inaugurated.\n\nThe most awaited moment was the arrival of the first boat: the legendary yacht Giralda, of His Royal Highness D. Juan, Count of Barcelona. Invited by Cupertino de Miranda, it was he who officially entered Vilamoura Marina, marking the beginning of a new era for Algarve tourism.",
          image: "/images/04-first-boat-vilamoura-marina-1974 - cópia.jpg"
        },
        vilamouraGrowth: {
          title: "Vilamoura Grows Around the Marina",
          content: "The marina was the heart of the project, but Vilamoura quickly began to take on a life of its own.\nWhat many considered excessive, a thousand berths for boats, became the engine that attracted national and international visitors.\n\nIn the following years, hotels, golf courses, restaurants and leisure spaces were born that consolidated Vilamoura as a destination of excellence.",
          image: "/images/08-vilamoura-marina-aerial-1977 - cópia.jpg"
        },
        commerce: {
          title: "Commerce and Life in the Marina",
          content: "Shortly after its inauguration, in 1978, the Marina gained a commercial space that included more than 50 shops. There were hairdressers, ice cream parlors, jewelry stores, perfumeries, shoe stores, bookstores and even record stores (record shops). The first store to open was Geladaria Veneza, quickly becoming an iconic meeting point.\n\nThis shopping center brought modernity, diversity and life to the region, creating a true urban and tourist ecosystem.",
          image: "/images/10-vilamoura-marina-inland-to-ocean-1980 - cópia.jpg"
        },
        vilamouraToday: {
          title: "Vilamoura Today",
          content: "After 50 years, Vilamoura Marina remains the most prestigious and busy in Portugal. Around it grew a vibrant city, with dozens of tourist developments, luxury hotels, restaurants, bars and shops that employ more than 1,500 people.\n\nMore than a recreational port, the Marina has become the symbol of Vilamoura: innovation, quality and Mediterranean lifestyle.",
          image: "/images/1.jpg"
        },
        continuingStory: {
          title: "A Story that Continues",
          content: "From one man's vision was born one of the world's most emblematic tourist destinations.\nVilamoura Marina is today a landmark in Algarve history and a pride of Portugal."
        },
        timeline: {
          title: "Key Moments in Marina History",
          events: [
            { year: "1964", event: "Arthur Cupertino de Miranda purchases Quinta de Quarteira to create a major tourism project" },
            { year: "1971", event: "Construction of Vilamoura Marina begins" },
            { year: "1974", event: "Completion of Portugal's first marina. The Giralda yacht is the first to dock" },
            { year: "1978", event: "Opening of the Marina Shopping Center" },
            { year: "1997", event: "First Vilamoura Boat Show takes place" },
            { year: "2010", event: "First recognition as Best Marina in Portugal" },
            { year: "2015–2017", event: "Best International Marina (TYHA)" },
            { year: "2023", event: "First marina in Portugal with 5 Gold Anchor Platinum certification" },
            { year: "2024", event: "Beginning of construction of the new marina" },
            { year: "2025", event: "Completion of the new marina construction. Over 1000 berths, leisure center, commerce and tourism, icon of the Algarve" }
          ]
        }
      },
      slideshow: {
        title: "The Evolution of Vilamoura Marina",
        description: ""
      },
      activities: {
        title: "Activities in Vilamoura",
        description: "Discover the best experiences Vilamoura has to offer",
        items: [
          {
            title: "Golf",
            description: "5 world-class golf courses",
            icon: "golf"
          },
          {
            title: "Marina",
            description: "Private marina for 1,000 boats",
            icon: "anchor"
          },
          {
            title: "Beaches",
            description: "Golden sand beaches and crystal clear waters",
            icon: "beach"
          },
          {
            title: "Dining",
            description: "40+ restaurants with award-winning chefs",
            icon: "restaurant"
          },
          {
            title: "Sailing",
            description: "Unique sailing experiences and water sports",
            icon: "sail"
          },
          {
            title: "Padel",
            description: "Modern and fun sport for all ages",
            icon: "padel"
          },
          {
            title: "Lifestyle",
            description: "Experience the ultimate Mediterranean lifestyle",
            icon: "lifestyle"
          }
        ]
      },
      location: {
        title: "Prime Location",
        description: "Vilamoura is strategically located in the heart of the Algarve",
        content: "Just 20 minutes from Faro Airport, Vilamoura offers easy access to all major Algarve attractions, including Lagos, Albufeira, and Tavira. Its central location makes it the perfect starting point to explore the region."
      },
      values: {
        title: "Our Values",
        subtitle: "The principles that guide everything we do",
        items: [
          {
            icon: "⭐",
            title: "Quality",
            description: "We partner only with the finest establishments, ensuring every experience meets our high standards of excellence."
          },
          {
            icon: "🤝",
            title: "Partnership",
            description: "We believe in building strong relationships with local businesses, creating mutual value and sustainable growth."
          },
          {
            icon: "🎯",
            title: "Exclusivity",
            description: "Our members enjoy special access to experiences and offers not available to the general public."
          },
          {
            icon: "🌱",
            title: "Sustainability",
            description: "We're committed to promoting responsible tourism that benefits local communities and preserves our beautiful environment."
          },
          {
            icon: "💎",
            title: "Authenticity",
            description: "We focus on genuine, local experiences that showcase the true spirit and culture of the Algarve."
          },
          {
            icon: "❤️",
            title: "Service",
            description: "Our dedicated team is always ready to help, ensuring your experience with us is seamless and memorable."
          }
        ]
      },
      team: {
        title: "Meet Our Team",
        subtitle: "The passionate people behind We ❤️ Vilamoura",
        members: [
          {
            name: "Maria Silva",
            position: "Founder & CEO",
            bio: "With over 15 years in the tourism industry, Maria founded We ❤️ Vilamoura to create meaningful connections between travelers and the unique experiences that make Vilamoura special.",
            image: "/images/team/maria-silva.jpg"
          },
          {
            name: "João Santos",
            position: "Partnership Director",
            bio: "João leads our partner relations, ensuring we work with the best local businesses in Vilamoura to provide exceptional experiences for our members.",
            image: "/images/team/joao-santos.jpg"
          },
          {
            name: "Ana Costa",
            position: "Guest Experience Manager",
            bio: "Ana ensures every guest receives personalized attention and has access to the perfect experiences for their stay in beautiful Vilamoura.",
            image: "/images/team/ana-costa.jpg"
          }
        ]
      },
      cta: {
        title: "Discover our properties near the Marina",
        content: "Live Vilamoura's history up close. Discover our exclusive properties and become part of this unique story.",
        propertiesButton: "View Properties",
        propertiesLink: "https://cleverdetails.com"
      }
    },
    contact: {
      title: "Contact Us",
      form: {
        name: {
          label: "Name",
          placeholder: "Your name"
        },
        phone: {
          label: "Phone",
          placeholder: "Your phone number"
        },
        email: {
          label: "Email",
          placeholder: "your.email@example.com"
        },
        subject: {
          label: "Subject",
          placeholder: "Message subject"
        },
        message: {
          label: "Message",
          placeholder: "Your message here..."
        },
        submit: "Send Message",
        sending: "Sending..."
      }
    },
    itemDetails: {
      reviews: "reviews",
      bookNow: "Book Now",
      specialOffer: "You deserve it!",
      bookingNotice: "Bookings must be made directly with Clever Details team",
      bookingNotice2: "You must present your membership card upon arrival.",
      details: "Details",
      openingHours: "Opening Hours",
      location: "Location",
      bookingRequest: "Booking Request",
      bookingMessage: "Hi, I'm interested in booking {itemName} with the following special offer: {specialOffer}.\\n\\nPlease provide me with more information.",
      reviewsSection: {
        title: "Reviews",
        leaveReview: "Leave a Review",
        rating: "Rating",
        writeReview: "Write a Review",
        authorPlaceholder: "Your name",
        commentPlaceholder: "Write your comment...",
        submit: "Submit Review",
        submitting: "Submitting...",
        yourName: "Your name",
        writeComment: "Write your comment..."
      },
      dateList: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      }
    },
    shopping: {
      title: "Store",
      subtitle: "Discover our exclusive collection of Algarve products",
      addToCart: "Add to Cart",
      removeFromCart: "Remove from Cart",
      viewCart: "View Cart",
      cart: "Cart",
      cartEmpty: "Your cart is empty",
      total: "Total",
      checkout: "Checkout",
      quantity: "Quantity",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      price: "Price",
      cartItems: "Cart Items",
      cartTotal: "Cart Total",
      proceedToCheckout: "Proceed to Checkout",
      continueShopping: "Continue Shopping",
      removeItem: "Remove Item",
      updateQuantity: "Update Quantity"
    },
    checkout: {
      title: "Checkout",
      subtitle: "Complete your order",
      orderSummary: "Order Summary",
      shippingInfo: "Shipping Information",
      paymentInfo: "Payment Information",
      personalInfo: "Personal Information",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      postalCode: "Postal Code",
      country: "Country",
      cardNumber: "Card Number",
      expiryDate: "Expiry Date",
      cvv: "CVV",
      cardholderName: "Cardholder Name",
      placeOrder: "Place Order",
      processing: "Processing...",
      orderComplete: "Order Complete!",
      thankYou: "Thank you for your purchase!",
      orderNumber: "Order Number",
      contactConfirmation: "You will be contacted soon to confirm your purchase.",
      pickupLocationConfirmation: "You will be contacted to confirm the exact pickup location.",
      continueShopping: "Continue Shopping",
      subtotal: "Subtotal",
      shipping: "Shipping",
      total: "Total",
      freeShipping: "Free",
      required: "This field is required",
      invalidEmail: "Please enter a valid email",
      invalidPhone: "Please enter a valid phone number",
      invalidCard: "Please enter a valid card number",
      invalidExpiry: "Please enter a valid expiry date (MM/YY)",
      invalidCvv: "Please enter a valid CVV",
      pickupInformation: "Pickup Information",
      pickupLocation: "Pickup Location",
      selectPickupLocation: "Select pickup location",
      pickupDate: "Pickup Date",
      pickupTime: "Pickup Time",
      selectTime: "Select time",
      paymentMethod: "Payment Method",
      selectPaymentMethod: "Select Payment Method",
      creditCard: "Credit Card",
      soon: "(soon)",
      cash: "Cash"
     },
    shoppingItem: {
      backToShopping: "Back to Store",
      addToCart: "Add to Cart",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      description: "Description",
      specifications: "Specifications",
      reviews: "Reviews",
      relatedProducts: "More Items",
      quantity: "Quantity",
      price: "Price",
      category: "Category",
      availability: "Availability",
      shipping: "Shipping",
      returns: "Returns",
      warranty: "Warranty",
      features: "Features",
      dimensions: "Dimensions",
      weight: "Weight",
      material: "Material",
      origin: "Origin",
      brand: "Brand",
      sku: "SKU"
    }
  }
};

